<template>
   <div class="book">
    <div class="container btnP searchDV text-center pt-2">
        
      <button class="btn btn-info btnP" @click="prt()">طباعة</button>
    </div>

<div class="page1" >
    
      <div class="subpage">
          <div></div>
        <header class="row">
          <div class="col-4 pt-4">
            شركة الصافنات للنقل
          </div>
          <div class="col-4">
            <p class="text-center">بسم الله الرحمن الرحيم</p>
            <p class="text-center bld">اشعار سداد</p>
          </div>
          <div class="col-4 text-left">
            <img src="../../../public/static/img/logo.png" alt="" />
          </div>
        </header>
        <div class="">
<span> نفيد سيادتكم علماً بان الطالبة</span> 
<span> / </span>
<span> {{ stdData.Fname }} </span>
 <span> {{ stdData.Sname}} </span>
 <span> {{ stdData.Tname}} </span>
 <span> {{ stdData.Ffname}} </span>
<span class="pr-5"></span>
<span class="pr-5"></span>
 <span class="pr-5">بجامعة  /</span>
<span> {{coll}} </span>

        </div>
<div class="mt-3">
<span>قد قامت بسداد مبلغ  </span>
<span> {{items.amount}} </span>
<span> ريالاً </span>
<span class="pr-5">فقط وقدرة   </span>
<span> {{tafqeetNum(items.amount)}} </span>
<span> ريالاً </span>
<span> فقط لاغير </span>

  <span class="pr-5">والمشتركة فى خدمة </span>
    <span> / </span>
<span>{{srv}}</span>

</div>
<div class="mt-3">
<span ></span>
<span>فى الفترة من  </span>
<span> {{stdData.startSub}} </span>
<span> الى </span>
<span> {{ stdData.endSub}} </span>
</div>
<div>
  <table class="table  table-bordered p-0">
      <thead class="">
          <tr>
              <td>قيمة الاشتراك</td>
              <td>المبلغ المسدد</td>
              <td>الباقى</td>
          </tr>
      </thead>
      <tbody>
          <tr>
              <td> {{stdData.AmountSub}} </td>
              <td> {{payAmount}} </td>
              <td> {{remind}} </td>
          </tr>
      </tbody>
  </table>
</div>
<div>
    <span>نرجوا من سيادتكم التكرم بسداد باقى الملبغ </span>
    <span> ... شاكرين حسن إختياركم لنا </span>
</div>
<div>
    <span> كما يمكن السداد من خلال حسابنا البنكى فى بنك الرجحى على حساب </span>
    <span>123456789</span>
<span class="pr-5"></span>
    <span class="pr-5">جوال</span>
    <span> / </span>
    <span>0505575095</span>
</div>


      </div>
     
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import tafqeet from "../../js/Tafqeet";
import {mapGetters} from 'vuex';
import reportsLayout from "../../layouts/reportsLayout.vue";
export default {
name:"bill",
props:['items']
,
  computed: {
    ...mapGetters({
      load: "stdMod/GET_STDALL",
      college: "collagesMod/GET_ALLDATA",
      payment: "payMod/GET_ALLDATA",
    })
    },
data(){
    return{
       payAmount:0,
       stdData:'',
       coll:'',
       srv:'',
       remind:0,
       service:[
           { "id":1,"serve":"ذهاب وعودة"},
           { "id":2,"serve":"ذهاب فقط"},
           { "id":3,"serve":"عودة فقط"},
       ]
    };
},
created(){
 this.$emit("update:layout", reportsLayout);
 this.loadFunction();

},
methods:{
    loadFunction(){
        if(this.load != null){
       this.stdData = this.load.find((t)=> t.id == this.items.stdID);  
       var cl = this.college.find((t)=> t.id == this.stdData.Collage_id);
       this.coll = cl.collageName;
       var sr = this.service.find((t)=> t.id == this.stdData.transfareType_id);
       this.srv = sr.serve;
        }
        if(this.payment != null){
        var lst = this.payment.filter((t)=> t.id == this.items.stdID);
        if(lst != null){
          $.each(lst, function () {
           this.payAmount += this.amount;});
        }
        }
         this.remind = this.stdData.AmountSub - this.payAmount;
    },tafqeetNum(num){
            return tafqeet(num);
       }       }
}
</script>

<style lang="scss" scoped>
@import "../../../public/static/css/print.css";

.searchDV {
  height: 50px;
  width: 790px;
  background-color: white;
}
.bd {
  height: 940px;
}
thead{
 background-color: #d4d4d4; 
}
.bld{
    font-weight: bold;
    font-size: 18px;
}
.subpage{
    border: 2px #717171 dotted;
    padding: 7px;
}
.table td{
    padding: 0 ;
}
</style>